import {
  ControlledTable,
  ControlledTableProps,
  ControlledTableColumns,
  KeyGetter,
  RowType,
} from 'components/ControlledTable';
import { ReactElement, ReactNode } from 'react';
import { TotalsHeader } from './TotalsHeader';
import { XLSXDownloadButton } from './XLSXDownload';
import { reportTable } from './style.css';

type ReportTableProps<R extends RowType> = Pick<
  ControlledTableProps<R>,
  'defaultFilter' | 'renderTable' | 'queryParams' | 'storageKey'
> & {
  url: string;
  columns: ControlledTableColumns<R>;
  filterFields?: ReactNode;
};

export function ReportTable<R extends RowType>({
  url,
  filterFields,
  columns,
  storageKey,
  ...rest
}: ReportTableProps<R>): ReactElement {
  const getKey: KeyGetter = ({ filter, pageSize, pageIndex, sort, queryParams }) => {
    /*
    Same as `generic DRF key getter` exepct for
      * POST
      * passing sort as object
     */

    return {
      url,
      method: 'POST',
      body: {
        // FIXME
        ...filter,
        page_size: pageSize,
        page: pageIndex,
        ordering: sort
          ? {
              order: sort.direction || 'DESC',
              key: sort.key,
            }
          : undefined,
        ...queryParams,
      },
    };
  };

  return (
    <ControlledTable<R>
      pageSize={50}
      getKey={getKey}
      columns={columns}
      storageKey={storageKey ?? url}
      filterFields={filterFields}
      actions={<XLSXDownloadButton url={url} />}
      tableProps={{
        subHeaders: <TotalsHeader />,
        size: 'xs',
        fontSize: 'sm',
        variant: 'dark',
        hover: true,
        striped: true,
        fixed: false,
        clamped: false,
        tableClassName: reportTable,
        containerClassName: 'mb-2',
      }}
      {...rest}
    />
  );
}
